let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("8X8Co")]).then(() => parcelRequire('aSV4Z'));